export default "__VITE_ASSET__37c5e007__"